export default __webpack_public_path__ + "static/media/etherdischarge.4b12e787.png";